/**
 * Append practice-attribution UTM params to a financing provider's apply URL
 * so the provider's dashboard can attribute applications per surface. The
 * base URL stays bare in appConfig because each surface passes its own medium.
 */
export const withFinancingUtm = (applyUrl: string, medium: string): string => {
  try {
    const url = new URL(applyUrl);
    url.searchParams.set("utm_source", "practice");
    url.searchParams.set("utm_medium", medium);
    return url.toString();
  } catch {
    // A malformed tenant URL must never dead-button the CTA.
    return applyUrl;
  }
};
